var moduleMap = {
	"./bootstrap": () => {
		return Promise.all([__webpack_require__.e(6502), __webpack_require__.e(2036), __webpack_require__.e(5354), __webpack_require__.e(2412), __webpack_require__.e(5373), __webpack_require__.e(6471), __webpack_require__.e(4477), __webpack_require__.e(2338), __webpack_require__.e(2229), __webpack_require__.e(1524), __webpack_require__.e(9299), __webpack_require__.e(9725), __webpack_require__.e(6649), __webpack_require__.e(634)]).then(() => (() => ((__webpack_require__(90634)))));
	},
	"./Insights": () => {
		return Promise.all([__webpack_require__.e(2036), __webpack_require__.e(2412), __webpack_require__.e(6471), __webpack_require__.e(2338), __webpack_require__.e(1524), __webpack_require__.e(9299), __webpack_require__.e(9725), __webpack_require__.e(2599)]).then(() => (() => ((__webpack_require__(52599)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});